import useGamesList from './useGamesList';
const useGame = (gameKey) => {
    const { allGames } = useGamesList();
    if (!gameKey) {
        return undefined;
    }
    return allGames === null || allGames === void 0 ? void 0 : allGames.find((game) => game.gameKey === gameKey);
};
export default useGame;
